import { Loader } from "@screencloud/screencloud-ui-components";
import { FormattedMessage } from "react-intl";
import { FileViewer } from "./FileViewer";
import { UseFileViewerFileResult } from "./hooks/useFileViewerFile";
import { Stage, Unavailable, UnavailableTitle } from "./styles";

export interface FileViewerStageProps {
  view: UseFileViewerFileResult;
}

/** Loading, unavailable or viewer state for a file fetched by id. */
export const FileViewerStage = ({ view }: FileViewerStageProps) => {
  const { loading, title, source, onMediaError } = view;

  const renderContent = () => {
    if (loading) {
      return <Loader active inline />;
    }
    if (!source) {
      return (
        <Unavailable data-testid="file-viewer-unavailable">
          <UnavailableTitle>
            <FormattedMessage
              id="media_view.unavailable.title"
              defaultMessage="This file can't be opened"
            />
          </UnavailableTitle>
          <FormattedMessage
            id="media_view.unavailable.description"
            defaultMessage="It may have been deleted, or you may not have permission to view it."
          />
        </Unavailable>
      );
    }
    return <FileViewer source={source} title={title} onError={onMediaError} />;
  };

  return <Stage>{renderContent()}</Stage>;
};
